
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host {
  display: inline-block;
}
:host .breadcrumb-list {
  display: flex;
  flex-direction: row;
  list-style: none;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
}
:host .breadcrumb-list ::slotted(.breadcrumb-item-wrapper.collapsed-breadcrumbs) {
  color: var(--slh-color-neutral-shade-60, #62779F);
}
:host .breadcrumb-list ::slotted(.breadcrumb-item-wrapper:last-child) {
  pointer-events: none;
  color: var(--slh-color-neutral-shade-60, #62779F);
}
:host .breadcrumb-list ::slotted(.breadcrumb-item-wrapper:first-child) {
  padding-left: 0;
}
:host a {
  display: flex;
  align-items: center;
  font-family: var(--slh-default-font-family, "Open Sans");
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  font-size: var(--slh-base-xs-font-size, 14px);
  color: var(--slh-color-primary, #3B87D4);
  text-decoration: none;
}
:host a:hover {
  text-decoration: underline;
}
:host a .icon-wrapper {
  margin-right: 8px;
  fill: currentColor;
}
`;
